import React, {useEffect, useRef, useState} from "react";
import Select from "react-select";
import {Label, Spinner} from "reactstrap";

import { REQUIRED } from "../i18n/i18n";

const errorTextStyle = {
    color: 'red'
}

const spinnerStyle = {
    marginTop:'25px'
}

const SelectMultipleGeneric = ({
                                   title = null,
                                   isDisabled = false,
                                   initialValues = [],
                                   hasError = false,
                                   setExternalValue,
                                   provider,
                                   maxSelection = null,
                                   customFilter = {}
}) => {
    const [loading, setLoading] = useState(false)
    const [options, setOptions] = useState([])
    const [selectedOptions, setSelectedOptions] = useState([])

    const isMounted = useRef(true)

    useEffect(() => {
        return () => { isMounted.current = false }
    },[])

    useEffect(() => {
        setLoading(true)

        provider.getOptions(customFilter).then( result => {
            if(isMounted.current)
                setOptions(result || [])
        }).finally( ()=> {
            if(isMounted.current)
                setLoading(false)
        } )
    }, [])

    useEffect(() => {
        if(!isMounted.current)
            return

        if(initialValues.length === 0 || options.length === 0)
            return


        setLoading(true)

        handleOnChange(initialValues)

        setLoading(false)
    }, [ options ])

    const handleOnChange = values => {
        if (maxSelection !== null && values.length > maxSelection)
            return;
        
        const ids = values.map( val => val?.id)

        setSelectValues(ids)
        setExternalValue(values)
    }


    const setSelectValues = values => {
        let items = []

        values.forEach( val => {
            const item = options.find( i => i.id === val )

            if(item)
                items.push( item )
        })

        setSelectedOptions( items )
    }

    return loading ? <Spinner animation="border" style={ spinnerStyle } /> : <>
        {
            title && <>
                <Label style={ hasError ? errorTextStyle : {} }>{title}</Label>
                <br/>
            </>
        }
        <Select
            isMulti
            isLoading={loading}
            value={selectedOptions}
            options={options}
            isDisabled={isDisabled}
            onChange={handleOnChange}
            className="basic-multi-select"
            classNamePrefix="select"
            styles={{
                control: (baseStyles, ) => ({
                    ...baseStyles,
                    borderColor: hasError ? 'red' : '',
                }),
            }}
        />
        { hasError && <div className="is-invalid" style={ errorTextStyle }>  {REQUIRED} </div> }
    </>
}

export default SelectMultipleGeneric